import React from "react";
import {
    Accordion,
    AccordionItem,
    AccordionItemPanel,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemState,
} from "react-accessible-accordion";
import { Heading } from "components";
import { Img } from "components";

interface AccordionFAQBlockProps {
    data: { question: string; answer: string }[];
}

export const AccordionFAQBlock: React.FC<AccordionFAQBlockProps> = ({ data }) => {
    const allExpandedIds = data.map((_, i) => i.toString());

    return (
        <Accordion
            allowMultipleExpanded={true}
            allowZeroExpanded={true}
            preExpanded={allExpandedIds}
            className="flex-col self-stretch"
        >
            {data.map((d, i) => (
                <AccordionItem uuid={i.toString()} key={`faq-${i}`}>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            <AccordionItemState>
                                {({ expanded }) => (
                                    <div className="flex items-center justify-between gap-5 py-4">
                                        <Heading size="desktop_body_xl_bold" className="text-[#191C30E5]">
                                            {d.question}
                                        </Heading>
                                        <Img
                                            src="/images/img_arrow_up_new_FAQ.svg"
                                            alt="Arrow"
                                            className={`transition-transform duration-300 ${
                                                expanded ? "rotate-0" : "rotate-180"
                                            }`}
                                        />
                                    </div>
                                )}
                            </AccordionItemState>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <div className="mb-5">
                            <Heading size="desktop_body_xl" className="text-[#191C30E5] font-normal">
                                {d.answer}
                            </Heading>
                        </div>
                        <div className="mt-3 h-px w-full bg-[#5C636B]" />
                    </AccordionItemPanel>
                </AccordionItem>
            ))}
        </Accordion>
    );
};
